import React, { useRef, useState } from "react";
import DeletIcon from "../../Assests/Dashboard/delete.svg";
import Edit from "../../Assests/Dashboard/edit.svg";
import Switch from "@mui/material/Switch";
import { Link } from "react-router-dom";
import { Grid, Tooltip, tooltipClasses } from "@mui/material";
import { useDispatch } from "react-redux";
import { useAuthDetails } from "../../Common/cookiesHelper";
import PasswordShow from "../../Common/passwordShow";
import {
  deleteMixAndMatchPricingDeal,
  enableDisableMixAndMatchPricingDeal,
} from "../../Redux/features/MixAndMatch/mixAndMatchSlice";
import { ToastifyAlert } from "../../CommonComponents/ToastifyAlert";
import CircularProgress from "@mui/material/CircularProgress";
import DeleteModal from "../../reuseableComponents/DeleteModal";
import { PERMISSIONS } from "../../Constants/permission";
import AccessDeniedTooltip from "../../reuseableComponents/AccessDeniedTooltip";
import { useSelector } from "react-redux";
import { styled } from "@mui/material/styles";
const BootstrapTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} arrow classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.arrow}`]: {
    color: "#f5f5f9",
    "&::before": {
      border: "1px solid #dadde9",
    },
  },
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: "var(--qv-bg-f5f5f9, #f5f5f9)",
    color: "var(--qv-tx-a0x0x0x870, rgba(0, 0, 0, 0.87))",
    maxWidth: 1000,
    whiteSpace: "normal",
    overflowWrap: "break-word",
    fontSize: theme.typography.pxToRem(13),
    border: "1px solid var(--qv-bd-dadde9, #dadde9)",
  },
}));

const SingleDeal = ({ deal, fetchDeals, setDealsList }) => {
  const dispatch = useDispatch();
  const { permissions, status, error } = useSelector(
    (state) => state.permissions
  );
  const { userTypeData, LoginGetDashBoardRecordJson } = useAuthDetails();
  const { handleCoockieExpire, getUnAutherisedTokenMessage } = PasswordShow();
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [getDeleteId, setDeleteId] = useState("");
  const [loaders, setLoaders] = useState({
    deleteLoader: { loading: false, id: "" },
    enableDisableLoader: { loading: false, id: "" },
  });
  const deleteInFlightRef = useRef(false);
  const enableDisableInFlightRef = useRef(false);

  const confirmDeletePop = (id) => {
    if (deleteInFlightRef.current || loaders.deleteLoader.loading) {
      return;
    }
    setDeleteModalOpen(true);
    setDeleteId(id);
  };

  const handleDeleteDeal = async () => {
    if (
      !getDeleteId ||
      deleteInFlightRef.current ||
      loaders.deleteLoader.loading
    ) {
      return;
    }
    deleteInFlightRef.current = true;
    try {
      setLoaders((prev) => ({
        ...prev,
        deleteLoader: { loading: true, id: getDeleteId },
      }));

      const data = {
        ...userTypeData,
        merchant_id: LoginGetDashBoardRecordJson?.data?.merchant_id,
        mix_id: getDeleteId,
      };

      const result = await dispatch(
        deleteMixAndMatchPricingDeal(data)
      ).unwrap();
      setDeleteId("");
      setDeleteModalOpen(false);
      if (result.success) {
        ToastifyAlert(result.message, "success");
        setDealsList((prev) => {
          const data = prev.filter((deal) => deal.id !== getDeleteId);
          return data;
        });
        // fetchDeals();
      } else {
        ToastifyAlert("Something went wrong!", "error");
      }
    } catch (error) {
      if (error?.status == 401) {
        handleCoockieExpire();
        getUnAutherisedTokenMessage();
      }
    } finally {
      deleteInFlightRef.current = false;
      setLoaders((prev) => ({
        ...prev,
        deleteLoader: { loading: false, id: "" },
      }));
    }
  };

  const hasEditMixNMatchPermission =
    !permissions.length ||
    permissions.indexOf(PERMISSIONS.MENU_EDIT_MIX_N_MATCH) > -1;
  const hasDeleteMixNMatchPermission =
    !permissions.length ||
    permissions.indexOf(PERMISSIONS.MENU_DELETE_MIX_N_MATCH) > -1;

  const handleEnableDisableDeal = async (dealId) => {
    if (
      enableDisableInFlightRef.current ||
      loaders.enableDisableLoader.loading
    ) {
      return;
    }
    enableDisableInFlightRef.current = true;
    try {
      setLoaders((prev) => ({
        ...prev,
        enableDisableLoader: { loading: true, id: dealId },
      }));

      const data = {
        ...userTypeData,
        merchant_id: LoginGetDashBoardRecordJson?.data?.merchant_id,
        mix_id: dealId,
        is_enable: deal.is_enable === "1" ? "0" : "1",
      };

      const result = await dispatch(
        enableDisableMixAndMatchPricingDeal(data)
      ).unwrap();

      if (result.success) {
        ToastifyAlert(result.message, "success");
        setDealsList((prev) => {
          const data = prev.map((deal) =>
            deal.id === dealId
              ? {
                  ...deal,
                  is_enable: deal.is_enable === "1" ? "0" : "1",
                }
              : deal
          );
          return data;
        });
        // fetchDeals();
      } else {
        ToastifyAlert("Something went wrong!", "error");
      }
    } catch (error) {
      if (error?.status == 401) {
        handleCoockieExpire();
        getUnAutherisedTokenMessage();
      }
    } finally {
      enableDisableInFlightRef.current = false;
      setLoaders((prev) => ({
        ...prev,
        enableDisableLoader: { loading: false, id: dealId },
      }));
    }
  };

  return (
    <Grid key={deal.id} item xs={12} sm={6} lg={4}>
      <Grid
        container
        className={`q_copuon_header w-full ${
          deal.is_enable === "1" ? "active" : ""
        }`}
      >
        <Grid
          item
          xs={12}
          sx={{ px: 1 }}
          className="mix-and-match-design"
          style={{ overflow: "hidden" }}
        >
          <Grid
            container
            direction="row"
            justifyContent="space-between"
            alignItems="center"
            sx={{ pt: 1, pb: 0.5 }}
            wrap="nowrap"
          >
            <Grid item xs={10} className="single-deal qv-mix-card-title">
              <Grid container>
                <Grid item xs={7} md={8} lg={12}>
                  <BootstrapTooltip
                    placement="bottom-start"
                    title={
                      <div style={{ fontWeight: 400, fontSize: "17px" }}>
                        {deal.deal_name}
                      </div>
                    }
                  >
                    <p
                      className="categories-title"
                      style={{ fontWeight: 500, fontSize: "20px" }}
                    >
                      {deal.deal_name
                        ? `${deal.deal_name.slice(0, 30)} ${
                            deal.deal_name.length > 30 ? "..." : ""
                          }`
                        : ""}
                    </p>
                  </BootstrapTooltip>
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={2} className="qv-mix-card-actions">
              <Grid container spacing={1} justifyContent="end" wrap="nowrap">
                <Grid item className="qv-promo-card-action">
                  {hasEditMixNMatchPermission ? (
                    <Link
                      to={
                        loaders.deleteLoader.loading &&
                        loaders.deleteLoader.id === deal.id
                          ? "/promotions/mix-and-match"
                          : `/promotions/mix-and-match/update/${deal.id}`
                      }
                    >
                      <span>
                        <img
                          src={Edit}
                          alt=""
                          className="h-8 w-8 cursor-pointer"
                        />
                      </span>
                    </Link>
                  ) : (
                    <AccessDeniedTooltip hasPermission={false}>
                      <img
                        src={Edit}
                        alt=""
                        className="h-8 w-8 cursor-pointer"
                      />
                    </AccessDeniedTooltip>
                  )}
                </Grid>
                <Grid
                  item
                  className="qv-promo-card-action"
                  display={"flex"}
                  justifyContent={"center"}
                  alignItems={"center"}
                >
                  {/* {loaders.deleteLoader.loading &&
                  loaders.deleteLoader.id === deal.id ? (
                    <span
                      style={{
                        heigh: "32px",
                        width: "32px",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <CircularProgress
                        color={"inherit"}
                        width={16}
                        size={16}
                      />
                    </span> */}
                  {/* // ) : ( */}
                  {hasDeleteMixNMatchPermission ? (
                    <img
                      src={DeletIcon}
                      alt="delete icon"
                      className="h-8 w-8 delet-icon"
                      // onClick={() => handleDeleteDeal(deal.id)}
                      onClick={() => confirmDeletePop(deal.id)}
                    />
                  ) : (
                    <AccessDeniedTooltip hasPermission={false}>
                      <img
                        src={DeletIcon}
                        alt="delete icon"
                        className="h-8 w-8 delet-icon cursor-pointer"
                      />
                    </AccessDeniedTooltip>
                  )}
                  {/* // )} */}
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          <Grid container sx={{ px: 0, pb: 1 }}>
            <Grid item xs={12}>
              <p className="offer-desc">
                {`Buy ${deal.min_qty} get ${
                  deal.is_percent === "1"
                    ? `${deal.discount}%`
                    : `$${deal.discount}`
                } off each`}
              </p>
            </Grid>
          </Grid>

          <Grid container sx={{ px: 0 }}>
            <Grid item xs={12} className="enable-disable-coupon-android">
              <div className="q_coupon_status_btn mixmatchEnable coupon-discount-for-android">
                <p>Enable/Disable</p>

                {loaders.enableDisableLoader.loading &&
                loaders.enableDisableLoader.id === deal.id ? (
                  <span
                    style={{
                      height: "38px",
                      width: "60px",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <CircularProgress color={"inherit"} width={16} size={16} />
                  </span>
                ) : (
                  <Switch
                    checked={deal.is_enable === "1"}
                    onChange={() => handleEnableDisableDeal(deal.id)}
                    disabled={
                      loaders.enableDisableLoader.loading &&
                      loaders.enableDisableLoader.id === deal.id
                    }
                    sx={{
                      "& .MuiSwitch-switchBase.Mui-checked": {
                        color: "var(--qv-tx-0a64f9, #0A64F9)",
                      },
                      "& .MuiSwitch-track": {
                        backgroundColor: "#0A64F9",
                      },
                    }}
                  />
                )}
              </div>
            </Grid>
          </Grid>

          <DeleteModal
            modalClassName="qv-promo-feedback-modal"
            headerText="Mix N' Match Pricing"
            open={deleteModalOpen}
            onClose={() => {
              if (loaders.deleteLoader.loading) return;
              setDeleteModalOpen(false);
              setDeleteId("");
            }}
            deleteloading={loaders.deleteLoader.loading ? true : false}
            onConfirm={handleDeleteDeal}
          />
        </Grid>
      </Grid>
    </Grid>
  );
};

export default SingleDeal;
